import {
  Autocomplete,
  DatePicker,
  Dropdown,
  Popover,
  Select,
  Tooltip,
} from '@nextui-org/react';

/**
 * NextUI overlay defaults that leave a ghost on Windows after close:
 * Tooltip closeDelay is 500ms, and Select/Dropdown/Popover exit motion often
 * does not paint, so the list stays visible for a few hundred ms.
 */
const overlayDefaults = { disableAnimation: true };

function applyOverlayDefaults(
  Component: object,
  extras: Record<string, unknown> = {}
) {
  Object.assign(Component as { defaultProps?: Record<string, unknown> }, {
    defaultProps: {
      ...overlayDefaults,
      ...extras,
    },
  });
}

applyOverlayDefaults(Tooltip, { closeDelay: 0 });
applyOverlayDefaults(Dropdown);
applyOverlayDefaults(Popover);
applyOverlayDefaults(Select, {
  popoverProps: { disableAnimation: true, triggerScaleOnOpen: false },
});
applyOverlayDefaults(Autocomplete);
applyOverlayDefaults(DatePicker);
